import ComponentWrapper from "../ComponentWrapper";
import { MediaContextProvider } from "../ComponentWrapper/Media";
import "./style/index.css";
import cx from 'classnames';
import React from 'react';
var NoAccessPage = function NoAccessPage(props) {
  var switchAccountHref = props.switchAccountHref,
    isFrAccount = props.isFrAccount;
  return /*#__PURE__*/React.createElement(MediaContextProvider, null, /*#__PURE__*/React.createElement(ComponentWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: cx('no-access-page')
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://hwobs.fanruan.com/ui/stop.png",
    className: cx('no-access-page-img')
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('no-access-page-tip')
  }, "\u62B1\u6B49\uFF0C\u8BE5\u8D26\u53F7\u65E0\u6743\u8BBF\u95EE\u6B64\u529F\u80FD"), isFrAccount ? /*#__PURE__*/React.createElement("div", {
    className: cx('no-access-page-reason')
  }, "\u5982\u9700\u6388\u6743\u8BF7\u901A\u8FC7\u53F3\u4FA7\u300C\u8054\u7CFB\u6211\u4EEC - \u9875\u9762\u53CD\u9988\u300D\u63D0\u4EA4\u9700\u6C42\uFF0C\u6216\u8054\u7CFB groots-\u590F\u98DE\u7FD4") : /*#__PURE__*/React.createElement("div", {
    className: cx('no-access-page-reason')
  }, "\u672C\u529F\u80FD\u4EC5\u5BF9\u5E06\u8F6F\u5185\u90E8\u7528\u6237\u5F00\u653E\uFF0C\u8BF7\u786E\u8BA4\u5F53\u524D\u767B\u5F55\u8D26\u53F7\u662F\u5426\u6B63\u786E", ' ', /*#__PURE__*/React.createElement("a", {
    href: switchAccountHref
  }, "\u5207\u6362\u8D26\u53F7")))));
};
export default NoAccessPage;